import { TripDetail } from '../../../../../core';
import { environment } from '../../../../../../environments/environment';
import { SUPERMERCADOS_CODE } from '../../../../../core/configs/company.config';
export const detailTrip = {
  hasDisabledCheckBoxItem: (row: any, selection: any[], data: any) => {
    let countStateDispatch = 0;
    if (row && row.itemList) {
      row.itemList.forEach(value => {
        if (!value.stateDispatch) {
          countStateDispatch++;
        }
      });
    }

    if ((row.itemList && countStateDispatch === row.itemList.length) || (row.deliveryTripStateId !== 16 && row.stateTrip === 'EN TRANSITO')) {
      if (data) {
        data.deselect(row);
      }
      return true;
    } else {
      return false;
    }
  },

  classValidation: (row: any) => {
    if (row.invalid) {
      return 'pending';
    }
    return '';
  },

  filter: false,
  searchText: 'Buscar despacho',
  checkbox: true,
  expandable: true,
  disabled: false,
  isButtonDisabled: true,
  paginatorAllData: true,
  partialField: '',
  exportFile: 'reporte_del_viaje.xlsx',
  iconsOfActions: [
    {
      icon: 'printer', tooltip: 'Imprimir guía de cliente',
      hasVisibleCondition: (): boolean => {
        const companyCode = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code;
        if (companyCode && companyCode === SUPERMERCADOS_CODE) {
          return true;
        } else {
          return false;
        }
      }
    },
    {
      icon: 'deliver', tooltip: 'Despachar',
      hasVisibleCondition: (element: any[]): boolean => {
        if (element[0] && element[0].stateTrip && element[0].stateTrip === 'EN TRANSITO') {
          return true;
        } else {
          return false;
        }
      }
    },
    {
      icon: 'trash', tooltip: 'Retirar despacho',
      hasVisibleCondition: (element: any[]): boolean => {
        if (element[0] && element[0].stateTrip && element[0].stateTrip === 'CREADO') {
          return true;
        } else {
          return false;
        }
      }
    }
  ],
  columns: [
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: false,
      class: 'left',
      value: (element: TripDetail) => element.saleNoteId
    },
    {
      title: 'N° Desp',
      name: 'dispatchId',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripDetail) => element.dispatchId
    },
    {
      title: 'Entidad',
      name: 'currentEntityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripDetail) => element.itemList && element.itemList[0] ?
        element.itemList[0].currentEntityName : ''
    },
    {
      title: 'Zona',
      name: 'zoneName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripDetail) => element.zoneName
    },
    {
      title: 'F. Entrega inicial',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripDetail) => element.deliveryDate
    },
    {
      title: 'F. Entrega real',
      name: 'realDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.realDate
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.endDateDeliveryWindow
    },
    {
      title: 'Cant. Solicitada',
      name: 'requestAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.requestAmount
    },
    {
      title: 'Cant. Entregada',
      name: 'deliveredQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.deliveredQuantity
    },
    {
      title: 'Estado',
      name: 'deliveryTripState',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.deliveryTripState
    },
    {
      title: 'Estado de Pago',
      name: 'statusPayment',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.statusPayment
    },
    {
      title: 'Agrupación de entidad origen',
      name: 'originEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.originEntityGroupName
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.groupName
    },
    {
      title: 'Agrupación de entidad siguiente',
      name: 'nextEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.nextEntityGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.finalEntityGroupName
    }
  ]
};
